export default __webpack_public_path__ + "static/media/token1.db8d977a.jpg";